import { apiHeaderOptions } from './apiHeaderOptions';
import api from 'api';

interface NifiReportPayload {
  apps: string;
  source?: string;
  startDate?: string;
  endDate?: string;
}

const fetchNifiReport = async (payload: NifiReportPayload) => {
  const { apps, source, startDate, endDate } = payload;
  const url = api.config.nifiReport(apps, source, startDate, endDate);
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

const fetchNifiDailyTrends = async (payload: NifiReportPayload) => {
  const { apps, source, startDate, endDate } = payload;
  const url = api.config.nifiDailyTrends(apps, source, startDate, endDate);
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

export const nifiReportService = {
  fetchNifiReport,
  fetchNifiDailyTrends
};
